import { Observable } from 'rxjs';
import { CollectionFilterKey } from '@web/common';
import { TableFilterType } from '../enums/table-filter-type';
import { Nillable } from '@web/utils';
import { SelectItem } from '../../select-item/models/select-item';

export class TableFilterConfig<Filter, Dictionary = never> {
  public constructor(
    public readonly key: CollectionFilterKey<Filter>,
    public readonly filterable: boolean,
    public readonly type: TableFilterType,
    public readonly selectItems$: Nillable<
      Observable<SelectItem<Dictionary>[]>
    >,
  ) {}
}
